import { requestBuilder } from '../../../http/RequestBuilder';

export const useUpdateBeneficiary = requestBuilder.mutation<
    {
        success: boolean;
    },
    Array<{
        id: string;
        bankAccountId: string;
        percentage: number;
    }>
>({
    endpoint: '/api/beneficiary/update',
    method: 'PATCH',
});
